import {RiskModel} from "@/services/ModelRisk/RiskModel";

export class MsScoreCatalogRepository {

    async categories() {
        let result = await fetch(`${RiskModel.endpoint}/catalog/categories`)
        return result.json();
    }

    async all() {
        let result = await fetch(`${RiskModel.endpoint}/groups?model_risk_id=1&version=1`)
        return result.json();
    }

    async getItemsByCategory(categoryId) {
        let result = await fetch(`${RiskModel.endpoint}/catalog/${categoryId}/items`)
        return result.json();
    }

    async create(category, description, percentage) {
       let result = await fetch(`${RiskModel.endpoint}/catalog`, {
            method: "POST",
            body: JSON.stringify({
                category,
                description,
                percentage
            })
        })

        return result.json();
    }
}
